// The customer list a Portfolio Entry shows on. Customer UI calls the
// portfolio list Monitoring and the pipeline list One-time.
export enum PortfolioCompanyStatus {
  PORTFOLIO = "portfolio",
  PIPELINE = "pipeline",
}

export const dataByPortfolioCompanyStatus: Record<
  PortfolioCompanyStatus,
  { label: string }
> = {
  [PortfolioCompanyStatus.PORTFOLIO]: { label: "Monitoring" },
  [PortfolioCompanyStatus.PIPELINE]: { label: "One-time" },
}

// An entry's list follows its Mode: monitored on Monitoring, a snapshot on
// One-time.
export const portfolioListOf = (isMonitoring: boolean) =>
  isMonitoring
    ? PortfolioCompanyStatus.PORTFOLIO
    : PortfolioCompanyStatus.PIPELINE
